import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import Logo from '../ui/Logo';
import ContactForm from '../forms/ContactForm';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-200">
      {/* CTA Footer Section */}
      <div className="bg-primary-800 text-white py-12 md:py-16">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Не нашли нужное оборудование? Оставьте заявку!
          </h2>
          <p className="text-lg mb-8 max-w-2xl mx-auto opacity-90">
            Мы подберем оптимальное решение и предложим выгодную цену в кратчайшие сроки.
          </p>
          <div className="max-w-xl mx-auto">
            <ContactForm buttonText="Оставить заявку" labelClassName="text-white" />
          </div>
        </div>
      </div>

      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <Logo color="white" />
            </div>
            <p className="text-gray-400 mb-6">
              Поставщик трансформаторов ТСЛ, ТСЗ, ТМГ а также КТПН, ЩНН, КСО, Силового кабеля для
              промышленных предприятий, строительных компаний во всех регионах РФ
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 15h-2v-6h2v6zm-1-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5 7h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-6h2v1.1c.52-.77 1.17-1.1 2-1.1 1.66 0 3 1.34 3 3v3z" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Быстрые ссылки</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/catalog" className="text-gray-400 hover:text-white transition-colors">
                  Каталог продукции
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  О компании
                </Link>
              </li>
              <li>
                <Link to="/advantages" className="text-gray-400 hover:text-white transition-colors">
                  Преимущества
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-white transition-colors">
                  Услуги
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-gray-400 hover:text-white transition-colors">
                  Проекты
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-white transition-colors">
                  Блог
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Оборудование</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/catalog/transformers"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Трансформаторы ТСЛ и ТСЗ
                </Link>
              </li>
              <li>
                <Link to="/ktpn" className="text-gray-400 hover:text-white transition-colors">
                  КТПН
                </Link>
              </li>
              <li>
                <Link
                  to="/catalog/kso"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  КСО
                </Link>
              </li>
              <li>
                <Link
                  to="/catalog/switchgear"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Щиты ВРУ ЩНН
                </Link>
              </li>
              <li>
                <Link
                  to="/catalog/cable"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Кабель
                </Link>
              </li>
              <li>
                <Link
                  to="/catalog/turnkey"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Комплектация под ключ
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Контакты</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <Phone className="h-5 w-5 text-primary-400 mr-3 mt-0.5" />
                <div>
                  <p className="text-white">+7 (913) 770-11-39</p>
                </div>
              </li>
              <li className="flex items-start">
                <Mail className="h-5 w-5 text-primary-400 mr-3 mt-0.5" />
                <div>
                  <a
                    href="mailto:prominnova@mail.ru"
                    className="text-white hover:text-primary-300 transition-colors"
                  >
                    prominnova@mail.ru
                  </a>
                  <p className="text-gray-400 text-sm">Для заявок и вопросов</p>
                </div>
              </li>
              <li className="flex items-start">
                <MapPin className="h-5 w-5 text-primary-400 mr-3 mt-0.5" />
                <div>
                  <p className="text-white">г. Новосибирск, ул. Бетонная 8а</p>
                  <p className="text-gray-400 text-sm">Офис и склад</p>
                </div>
              </li>
              <li className="flex items-start">
                <Clock className="h-5 w-5 text-primary-400 mr-3 mt-0.5" />
                <p className="text-white">Пн-Пт: с 10:00 до 22:00</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom footer */}
      <div className="border-t border-gray-800">
        <div className="container-custom py-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Проминнова. Все права защищены.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
